import script from "./authModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./authModal.vue?vue&type=script&setup=true&lang=ts"

import "./authModal.vue?vue&type=style&index=0&id=86d8f95e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d8f95e"]])

export default __exports__